import { motion } from 'framer-motion';
import { Diamond, Heart, MessageCircle, Sparkles } from 'lucide-react';

const ShoutOutsPage = () => {
  const shoutOuts = [
    "The fact that she interacts so great with all of her viewers!",
    "Her Joyful personality",
    "THE WHOLE WELCOMING AND LAID BACK VIBES",
    "When shayla wins duhh!! But seriously just the community she's built and bringing people together and everyone networking always great",
    "The fun bonuses!",
    "You are exactly what your name says you are…Relatable! Funny conversations and gaming",
    "SHAYLA DUHHHHHHHH",
    "Shayla's love for her community. She is so awesome her energy is everything",
    "We Hangout, have fun and all are welcome. Just a really chill group Shay reels in. Shay does really great explaining things when there new and constantly reminding everyone when giveaways or bonus activities are active. It's a 10/10. And thank you again!",
    "Shayla is a blast and reads all our chats and comments and plays at the same time! Haha I could never multitask like that. Always enjoy her",
    "I like how she's positive and acknowledges her viewers. She doesn't demand kicks, views, likes, or subs in exchange for giving out the links like some streamers. She listens to her audience for slot calls as well",
    "Friendliness and great energy",
    "Fun times",
    "I always enjoy the stream!! Fun and entertaining!!",
    "Giveaways",
    "Fun",
    "I enjoy how friendly, and motivating she is and her personality!",
    "Her energy and positivity! She's the best!",
    "I love the fun community and lightheartedness of the streams :D",
    "Her attitude",
    "Having fun 😊",
    "I love her positivity.",
    "Her positivity",
    "Her vibes",
    "I liked doing the game calls.",
    "Everything her personality",
    "Shayla herself!",
    "Her positivity",
    "Everything... Shayla is the best!!",
    "Positivity / Genuine Personality",
    "Her uplifting attitude!! Always a blast to watch!",
    "The fact that you respond to all messages in stream",
    "I like her way with people. Very onto of welcoming people and conversations with chat!!!",
    "She is very upbeat and interactive with the chat!",
    "Her shes great",
    "Her enthusiasm",
    "She's absolutely adorable and fun!!!",
    "Shayla is the best",
    "Shayla's energy!!!",
    "Positivity",
    "Her sweet bubbly personality that is always uplifting",
    "I always love her streams! Entertaining and fun",
    "Positive always!",
    "Love her energy",
    "The interactivity with the chat.",
    "Her personality is KILLER",
    "Love her personality! She is fantastic and makes sure to acknowledge each and everyone watching",
    "EVERYTHING.... Shayla is an amazing streamer and so personable with everyone",
    "She's always interact with chat",
    "Her kindness to others",
    "The community spirit",
    "I enjoy the love she gives to her viewers and how she talks to you in her streams.",
    "She's great energy love her style!",
    "Love the legendz family!",
    "Love watching shayla!",
    "She is always so fun and upbeat",
    "Everything! Great personality and energy!",
    "The good vibes n positivity",
    "I like the battles",
    "She has such a positive attitude and is so friendly",
    "She's a hoot!",
    "The chat was really fun",
    "The love for her viewers and the extra games she does for us",
    "Shay loving happy personality",
    "Love the community!!!",
    "Shayla! She is so easy going and relaxing to watch.",
    "Her personality!",
    "Her vibe & personality are amazing!!",
    "Positive",
    "Community spirit",
    "Her positivity!",
    "She has a chill vibe",
    "Everything!!",
    "She is an awesome streamer",
    "The different races and seeing different games I may not usually play",
    "I always enjoy the positivity coming from everyone that engages in chat. I enjoy having a virtual space full of positive wonderful loving people!! 💜💜 I can't remember how I came across Shayla but I can honestly say that I am happy that I did!!",
    "THE VIBES AND THE FAAAAAM!"
  ];

  // Color palette for bubbles
  const bubbleColors = [
    { bg: 'rgba(157, 78, 221, 0.15)', border: 'rgba(157, 78, 221, 0.4)', text: '#E0E0E0' },
    { bg: 'rgba(57, 255, 20, 0.1)', border: 'rgba(57, 255, 20, 0.3)', text: '#E0E0E0' },
    { bg: 'rgba(88, 101, 242, 0.15)', border: 'rgba(88, 101, 242, 0.4)', text: '#E0E0E0' },
    { bg: 'rgba(255, 105, 180, 0.1)', border: 'rgba(255, 105, 180, 0.3)', text: '#E0E0E0' },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.05 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.4 } }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 px-4" data-testid="shoutouts-page">
      {/* Decorative blobs */}
      <div className="glow-blob glow-blob-purple top-40 -left-48 fixed" />
      <div className="glow-blob glow-blob-green bottom-40 -right-48 fixed" />

      <div className="max-w-7xl mx-auto relative">
        {/* Header */}
        <motion.section
          className="text-center mb-16"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div variants={itemVariants} className="flex items-center justify-center gap-2 mb-4">
            <Diamond className="w-5 h-5 text-[#39FF14] sparkle" />
            <span className="text-[#39FF14] font-medium uppercase tracking-wider text-sm">Community Love</span>
            <Diamond className="w-5 h-5 text-[#39FF14] sparkle" />
          </motion.div>

          <motion.h1 
            variants={itemVariants}
            className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase mb-6"
          >
            <span className="text-[#E0E0E0]">Relatable Community</span>
            <br />
            <span className="text-glow-purple text-[#9D4EDD]">Shout-Outs</span>
          </motion.h1>

          <motion.p 
            variants={itemVariants}
            className="text-lg text-gray-400 max-w-2xl mx-auto"
          >
            Love and appreciation from The Relatable Family! These are the amazing people 
            who make our community special. 💜
          </motion.p>

          <motion.div variants={itemVariants} className="flex justify-center gap-2 mt-6">
            <Heart className="w-6 h-6 text-[#FF69B4] fill-[#FF69B4]" />
            <span className="text-gray-400">{shoutOuts.length} shout-outs from the fam!</span>
            <Heart className="w-6 h-6 text-[#FF69B4] fill-[#FF69B4]" />
          </motion.div>
        </motion.section>

        {/* Shout-outs Bubbles */}
        <motion.section
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          <div className="flex flex-wrap justify-center gap-4">
            {shoutOuts.map((shoutOut, index) => {
              const colorScheme = bubbleColors[index % bubbleColors.length];
              const isLong = shoutOut.length > 100;
              
              return (
                <motion.div
                  key={index}
                  variants={itemVariants}
                  className={`relative group ${isLong ? 'w-full sm:w-auto sm:max-w-md' : ''}`}
                  data-testid={`shoutout-bubble-${index}`}
                >
                  <div 
                    className={`
                      px-5 py-3 rounded-2xl backdrop-blur-sm
                      border transition-all duration-300
                      hover:scale-105 hover:shadow-lg
                      ${isLong ? 'text-left' : 'text-center'}
                    `}
                    style={{
                      backgroundColor: colorScheme.bg,
                      borderColor: colorScheme.border,
                    }}
                  >
                    <p className="text-sm sm:text-base leading-relaxed" style={{ color: colorScheme.text }}>
                      "{shoutOut}"
                    </p>
                    
                    {/* Decorative sparkle on hover */}
                    <Sparkles 
                      className="absolute -top-2 -right-2 w-4 h-4 text-[#39FF14] opacity-0 group-hover:opacity-100 transition-opacity sparkle" 
                    />
                  </div>
                  
                  {/* Bubble tail */}
                  <div 
                    className="absolute -bottom-2 left-6 w-4 h-4 rotate-45"
                    style={{
                      backgroundColor: colorScheme.bg,
                      borderRight: `1px solid ${colorScheme.border}`,
                      borderBottom: `1px solid ${colorScheme.border}`,
                    }}
                  />
                </motion.div>
              );
            })}
          </div>
        </motion.section>

        {/* Call to Action */}
        <motion.section
          className="mt-16"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div 
            variants={itemVariants}
            className="glass-card p-8 text-center"
          >
            <div className="flex items-center justify-center gap-2 mb-4">
              <MessageCircle className="w-6 h-6 text-[#39FF14]" />
              <h2 className="text-xl font-bold text-[#E0E0E0]">Want to Be Featured?</h2>
            </div>
            <p className="text-gray-400 max-w-xl mx-auto">
              Join The Relatable Family on Discord and share your experience! 
              Your shout-out could be featured here.
            </p>
            <a
              href="https://discord.gg/FEwaZfwnN5"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-secondary px-8 py-3 rounded-full font-semibold inline-flex items-center justify-center gap-2 mt-6"
              data-testid="discord-shoutouts-btn"
            >
              Join Discord
            </a>
          </motion.div>
        </motion.section>
      </div>
    </div>
  );
};

export default ShoutOutsPage;
